import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["section", "button", "icon"]
  static values = { url: String }

  async refresh(event) {
    event.preventDefault()
    this.buttonTarget.disabled = true
    this.iconTarget.classList.add("fa-spin")

    try {
      const response = await fetch(this.urlValue, {
        headers: { "Accept": "text/html", "X-Requested-With": "XMLHttpRequest" },
        credentials: "same-origin"
      })
      if (!response.ok) throw new Error(`HTTP ${response.status}`)
      this.sectionTarget.innerHTML = await response.text()
    } catch (error) {
      console.error("Failed to refresh gift batches:", error)
    } finally {
      this.buttonTarget.disabled = false
      this.iconTarget.classList.remove("fa-spin")
    }
  }
}
